import './ceAuthentication.less';
import React, { useCallback, useEffect } from 'react';
import { AntSelect } from '../../../ant/ant-select/antSelect';
import { FieldWrapper } from './fieldWrapper';
import { FieldProps } from './types';
import { observer } from 'mobx-react';
import { FormBuilderContext } from 'controls/react/form/formBuilderNew/formBuilderContext';
import { Section } from 'controls/react/layout/section';
import { fieldNamesTextValue } from 'controls/react/ant/ant-select/types';
import AddAuthentication from 'controls/react/windows/addAuthentication';
import LocalEventsManager from 'core/localEventsManager';

const b = require('b_').with('ce-authentication');

// payload broadcast by the authentication form (opened in a modal of its own, outside of this React tree) over
// the app-wide LocalEventsManager bus — ported from the old formBuilder's sagas/authenticationSaved.js
interface AuthenticationSavedEvent {
	data?: { id: string };
}

export const CEAuthentication = observer(({ property }: FieldProps) => {
	const store = React.useContext(FormBuilderContext);
	const mode = property.multiSelect ? 'tags' : null;

	useEffect(() => {
		// only the root-level occurrence reacts — one nested inside a CECollection sub-form has its own,
		// unrelated value tree (ported from the old formBuilder's sagas/authenticationSaved.js)
		if (store.rootFormStore) return;
		const onAuthenticationSaved = (e: AuthenticationSavedEvent) => {
			if (e?.data?.id != null) {
				store.setPropertyValueIfExists(property.id, e.data.id, true);
			}
		};
		LocalEventsManager.bind('authenticationsaved', onAuthenticationSaved);
		return () => LocalEventsManager.unbind('authenticationsaved', onAuthenticationSaved);
	}, [store, property.id]);

	// AddAuthentication is the same "create new authentication" window used by AuthenticationSelector —
	// reuse it here instead of opening the authentication form by hand.
	const onCreated = useCallback(
		(data: { id: string }) => {
			store.loadDatasource(property, true);
			store.onPropertyValueChange(property, data.id);
		},
		[property, store],
	);

	return (
		<Section appearance={'none'} direction={'row'} contentClass={b('content')}>
			<FieldWrapper property={property}>
				<AntSelect mode={mode} fieldNames={fieldNamesTextValue} options={store.dataSources.get(property.id) || []} />
			</FieldWrapper>
			{/* property.authTypes is config data on the CEAuthentication field (old formBuilder exposed the same
			data via its VIRTUAL_DEPENDENCIES 'authId' -> 'authTypes' redux-form workaround) */}
			<AddAuthentication
				containerClass={b('add')}
				authTypes={property.authTypes ?? ['GENERIC']}
				onCreated={onCreated}
			/>
		</Section>
	);
});
